import { Dayjs } from 'dayjs';
import { FC, useEffect } from 'react';
import { formatDate, getDefaultDates } from 'src/utils/date-util';
import { callInventoryIssueTransaction } from 'src/utils/firebase/firebase-callable';

import useInventoryIssuesWithTransaction from 'src/hooks/subscription/useInventoryIssuesWithTransaction';
import useDateForTableOptions from 'src/hooks/useDateForTableOptions';
import { useTitle } from 'src/hooks/useTitle';

import InventoryIssueForm from 'src/atomic-components/molecules/InventoryIssueForm/InventoryIssueForm';
import InventoryIssueTable from 'src/atomic-components/organisms/Tables/InventoryIssueTable';
import TableOptions from 'src/components/Common/TableOptions/TableOptions';

const defaultValue = getDefaultDates(7, 0);
const dayjsesToStringDateWhere = (left: Dayjs, right: Dayjs): [string, string] => {
  const leftDate = formatDate(left.toDate(), 'yyyy-MM-dd');
  const rightDate = formatDate(right.toDate(), 'yyyy-MM-dd');
  return [leftDate, rightDate];
};

const InventoryIssueBoard: FC = () => {
  useTitle(`GU 관리자 | 재고 이슈`);
  const { dates, setDates, leftDate, rightDate } = useDateForTableOptions(dayjsesToStringDateWhere, defaultValue);
  const inventoryIssues = useInventoryIssuesWithTransaction(leftDate, rightDate);

  useEffect(() => {
    callInventoryIssueTransaction({
      body: null,
    }).then((res) => {
      console.log(`[preflight] callInventoryIssueTransaction: ${res.data.result}`, res);
    });
  }, []);

  return (
    <div className='height100 flexColumn'>
      <InventoryIssueForm />

      <div className='flexColumn height100'>
        <TableOptions setDates={setDates} defaultValue={dates} />
        <InventoryIssueTable rowData={inventoryIssues} />
      </div>
    </div>
  );
};

export default InventoryIssueBoard;
